// src/ThankYou.js
import React from "react";
import { Link } from "react-router-dom";

function ThankYou() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(to bottom, #0f172a, #0ea5e9)",
        padding: "20px"
      }}
    >
      <div
        style={{
          background: "#ffffff",
          maxWidth: "500px",
          width: "100%",
          padding: "40px",
          borderRadius: "20px",
          textAlign: "center",
          boxShadow: "0 20px 50px rgba(0,0,0,0.3)"
        }}
      >
        <h1 style={{ marginBottom: "10px" }}>You're In 🚀</h1>

        <p
          style={{
            marginBottom: "20px",
            color: "#555"
          }}
        >
          Check your email — I just sent you something important.
        </p>

        <div
          style={{
            marginBottom: "25px",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
          }}
        >
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/f1H8GlXcnSk"
            title="Makana Impact Story"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              border: "none",
              borderRadius: "16px"
            }}
          />
        </div>

        <p
          style={{
            marginBottom: "30px",
            fontSize: "14px",
            color: "#777",
            lineHeight: "1.6"
          }}
        >
          Appreciate you being here 🤙🏽
          <br />
          <br />
          Over time, I’ll share more of the journey, what I’m learning,
          and tools that are genuinely helping me grow step by step.
        </p>

        <Link
          to="/my-story"
          style={{
            display: "block",
            marginTop: "10px",
            padding: "16px 24px",
            border: "none",
            borderRadius: "12px",
            background: "#22c55e",
            color: "#fff",
            fontWeight: "bold",
            width: "100%",
            fontSize: "18px",
            textDecoration: "none",
            boxShadow: "0 10px 25px rgba(34,197,94,0.3)"
          }}
        >
          Watch My Story
        </Link>
      </div>
    </div>
  );
}

export default ThankYou;